module.exports = __webpack_public_path__ + "static/mccarthy-hall-4-thumb-585786ff6be1667ae9a3e41155506f71.jpg";